//#region src/helper.ts
function allEnumValues(tsEnum) {
	const values = Object.values(tsEnum);
	const numericValues = values.filter((value) => typeof value === "number");
	if (numericValues.length > 0) return numericValues;
	return values.filter((value) => typeof value === "string");
}
function isValidEnumValue(tsEnum, value) {
	return allEnumValues(tsEnum).includes(value);
}
function areValidEnumValues(tsEnum, values) {
	return values.every((value) => isValidEnumValue(tsEnum, value));
}
function mapEnumToRecord(tsEnum, mapper) {
	return allEnumValues(tsEnum).reduce((partialRecord, tsEnumKey) => {
		return {
			...partialRecord,
			[tsEnumKey]: mapper(tsEnumKey)
		};
	}, {});
}
//#endregion
export { allEnumValues, areValidEnumValues, isValidEnumValue, mapEnumToRecord };

//# sourceMappingURL=helper.js.map